// ======================================================================
// FILE:
// src/modules/finance/transactions/contra_voucher/services/contraVoucherService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// Contra Voucher
//
// PURPOSE:
// Frontend API Client for Finance Contra Voucher.
//
// RESPONSIBILITIES
// - Contra Voucher Header CRUD
// - Contra Voucher Workflow
// - No accounting logic
// - No React code
// - No UI logic
// - No Toast
// - No Navigation
// - No State Management
//
// ======================================================================

import axiosClient from "../../../../../api/axiosClient";

// ======================================================================
// API BASE URL
// ======================================================================

const BASE_URL =
    "/api/finance/contra-vouchers";

// ======================================================================
// LIST CONTRA VOUCHERS
// ======================================================================

async function listContraVouchers(
    filters = {}
) {

    const response =
        await axiosClient.get(
            BASE_URL,
            {
                params: filters,
            }
        );

    const data =
        response?.data?.data;

    /*
     * Keep the service flexible because the backend
     * currently returns the Contra Voucher collection
     * directly.
     */

    if (Array.isArray(data)) {

        return {
            rows: data,
            summary: {},
            pagination: {},
        };

    }

    return {

        rows:
            data?.rows ||
            data?.items ||
            data?.data ||
            [],

        summary:
            data?.summary ||
            {},

        pagination:
            data?.pagination ||
            {},

    };

}

// ======================================================================
// GET CONTRA VOUCHER
// ======================================================================

async function getContraVoucher(
    contraVoucherId
) {

    const response =
        await axiosClient.get(
            `${BASE_URL}/${contraVoucherId}`
        );

    return response.data.data;

}

// ======================================================================
// CREATE CONTRA VOUCHER
// ======================================================================

async function createContraVoucher(
    payload
) {

    const response =
        await axiosClient.post(
            BASE_URL,
            payload
        );

    return response.data.data;

}

// ======================================================================
// UPDATE CONTRA VOUCHER
// ======================================================================

async function updateContraVoucher(
    contraVoucherId,
    payload
) {

    const response =
        await axiosClient.put(
            `${BASE_URL}/${contraVoucherId}`,
            payload
        );

    return response.data.data;

}

// ======================================================================
// DELETE CONTRA VOUCHER
// ======================================================================

async function deleteContraVoucher(
    contraVoucherId,
    companyId
) {

    const response =
        await axiosClient.delete(
            `${BASE_URL}/${contraVoucherId}`,
            {
                params: {
                    company_id: companyId,
                },
            }
        );

    return response.data;

}

// ======================================================================
// SUBMIT CONTRA VOUCHER
// ======================================================================

async function submitContraVoucher(
    contraVoucherId,
    companyId
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/${contraVoucherId}/submit`,
            null,
            {
                params: {
                    company_id: companyId,
                },
            }
        );

    return response.data.data;
}
// ======================================================================
// APPROVE CONTRA VOUCHER
// ======================================================================

async function approveContraVoucher(
    contraVoucherId,
    companyId
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/${contraVoucherId}/approve`,
            null,
            {
                params: {
                    company_id: companyId,
                },
            }
        );

    return response.data.data;
}

// ======================================================================
// POST CONTRA VOUCHER
// ======================================================================

async function postContraVoucher(
    contraVoucherId,
    companyId
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/${contraVoucherId}/post`,
            null,
            {
                params: {
                    company_id: companyId,
                },
            }
        );

    return response.data.data;
}
// ======================================================================
// EXPORT
// ======================================================================

const contraVoucherService = {

    // --------------------------------------------------------------
    // Contra Voucher Header
    // --------------------------------------------------------------

    listContraVouchers,

    getContraVoucher,

    createContraVoucher,

    updateContraVoucher,

    deleteContraVoucher,

    // --------------------------------------------------------------
    // Workflow
    // --------------------------------------------------------------

    submitContraVoucher,

    approveContraVoucher,

    postContraVoucher,

};

export default contraVoucherService;